"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadyToApplyPrimaryContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../../../base-components/Button/Button");
var _Typography = require("../../../../base-components/Typography/Typography");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PropertyProvider = require("../../../../utils/PropertyProvider/PropertyProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ReadyToApplyPrimaryContainer = exports.ReadyToApplyPrimaryContainer = function ReadyToApplyPrimaryContainer(_ref) {
  var titleComponent = _ref.titleComponent,
    titleComponentStyles = _ref.titleComponentStyles,
    TitleComponentTag = _ref.TitleComponentTag,
    textComponents = _ref.textComponents,
    textComponentStyles = _ref.textComponentStyles,
    primaryButtonProps = _ref.primaryButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    ChildComponent = _ref.ChildComponent,
    namespace = _ref.namespace,
    qeId = _ref.qeId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rta-primary-container",
    "data-qe-id": qeId
  }, titleComponent && /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    components: titleComponent,
    styles: titleComponentStyles,
    ChildComponent: TitleComponentTag
  }), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    components: textComponents,
    styles: textComponentStyles,
    ChildComponent: ChildComponent,
    namespace: (0, _PropertyProvider.NS)(namespace, 'text')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rta-button-container"
  }, !!primaryButtonProps && /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({}, primaryButtonProps, {
    namespace: (0, _PropertyProvider.NS)(namespace, 'primary'),
    qeId: qeId ? "".concat(qeId, "-primaryButton") : undefined
  })), !!secondaryButtonProps && /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({}, secondaryButtonProps, {
    namespace: (0, _PropertyProvider.NS)(namespace, 'secondary'),
    qeId: qeId ? "".concat(qeId, "-secondaryButton") : undefined
  }))));
};
ReadyToApplyPrimaryContainer.propTypes = {
  titleComponent: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  titleComponentStyles: _propTypes["default"].objectOf(_propTypes["default"].string),
  TitleComponentTag: _propTypes["default"].string,
  textComponents: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  textComponentStyles: _propTypes["default"].objectOf(_propTypes["default"].string),
  primaryButtonProps: _propTypes["default"].shape(_Button.Button.propTypes),
  secondaryButtonProps: _propTypes["default"].shape(_Button.Button.propTypes),
  ChildComponent: _propTypes["default"].node,
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
ReadyToApplyPrimaryContainer.defaultProps = {
  titleComponent: {},
  titleComponentStyles: {},
  TitleComponentTag: 'h2',
  textComponents: {},
  textComponentStyles: {},
  primaryButtonProps: _Button.Button.defaultProps,
  secondaryButtonProps: _Button.Button.defaultProps,
  ChildComponent: undefined,
  namespace: '',
  qeId: undefined
};